import { callServiceMachine } from '_core/util';
import Machines from '../Machines';
import { ValidateLegalGuardianTypes } from '../Types';

const machine = Machines.onValidateLegalGuardian.machine;

export const validateLegalGuardian = (): Promise<ValidateLegalGuardianTypes.IValidateLegalGuardianServiceResponse> =>
  callServiceMachine(machine);

export default { validateLegalGuardian };
